import { render, staticRenderFns } from "./BatteryStockStatus.vue?vue&type=template&id=a118c2b6"
import script from "./BatteryStockStatus.vue?vue&type=script&lang=ts"
export * from "./BatteryStockStatus.vue?vue&type=script&lang=ts"
import style0 from "./BatteryStockStatus.vue?vue&type=style&index=0&id=a118c2b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports